'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var React = require('react');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var Skeleton_web = require('../Skeleton/Skeleton.web.cjs');
var Icon_web_styles = require('./Icon.web.styles.cjs');

/**
 * Used to display icons from the FontAwesome library
 *
 * {@link https://aviary.fullscript.io/latest/components/icon/web-DnnX5ecN | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Icon/Icon.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Icon = /*#__PURE__*/ React.memo(({ icon, variant = "noStyle", intention = "neutral", size = "medium", isLoading = false, customCss, ...remainingProps })=>{
    const theme = react.useTheme();
    const iconContainerStyles = React.useMemo(()=>[
            Icon_web_styles.container(theme, intention, size, variant)
        ], [
        theme,
        variant,
        intention,
        size
    ]);
    const baseIconStyles = React.useMemo(()=>Icon_web_styles.icon(theme, intention, size), [
        theme,
        intention,
        size
    ]);
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            isCircular: variant === "circular",
            height: theme.ds5.icon.backgroundHeight[size],
            width: theme.ds5.icon.backgroundWidth[size]
        });
    }
    if (variant === "noStyle") {
        return /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
            css: baseIconStyles,
            icon: icon,
            ...remainingProps
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: [
            iconContainerStyles,
            customCss
        ],
        "data-testid": "aviary-icon",
        children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
            css: baseIconStyles,
            icon: icon,
            "aria-hidden": "false",
            ...remainingProps
        })
    });
});
Icon.displayName = "Icon";

exports.Icon = Icon;
//# sourceMappingURL=Icon.web.cjs.map
